module.exports = __webpack_public_path__ + "img/appIcon-apps--SignupForms.0baeccc5.svg";